<template>
  <div class="login-container">
    <v-container class="fill-height pa-0" fluid>
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="login-card elevation-12 mx-5">
            <div class="login-header">
              <div class="text-center py-4">
                <h1 class="custom-title mb-1">iTPV Manager</h1>
                <h2 class="custom-subtitle">Login</h2>
              </div>
            </div>
            
            <v-card-text class="pa-6">
              <div class="subtitle-1 text-center mb-5">
                Ingrese sus credenciales
              </div>
              <v-form @submit.prevent="login" ref="form" v-model="valid">
                <v-text-field
                  v-model="username"
                  label="Usuario"
                  prepend-inner-icon="mdi-account"
                  :rules="[v => !!v || 'El usuario es requerido']"
                  required
                  outlined
                  dense
                  color="primary"
                  class="mb-4"
                ></v-text-field>
                
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[v => !!v || 'La contraseña es requerida']"
                  required
                  outlined
                  dense
                  color="primary"
                  class="mb-6"
                ></v-text-field>
                
                <v-btn 
                  :loading="loading" 
                  color="primary" 
                  type="submit" 
                  block 
                  x-large 
                  class="mb-2"
                  :disabled="!valid"
                >
                  <v-icon left>mdi-login</v-icon>
                  Iniciar Sesión
                </v-btn>
                
                <v-alert 
                  v-if="error" 
                  type="error" 
                  dense 
                  class="mt-4"
                  border="left"
                  text
                  prominent
                >
                  {{ error }}
                </v-alert>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from '../plugins/axios';

export default {
  name: 'LoginForm',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: '',
      showPassword: false,
      valid: false
    };
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      this.error = '';
      try {
        const res = await axios.post('/api/auth/login', {
          username: this.username,
          password: this.password
        });
        
        localStorage.setItem('token', res.data.token);
        
        const userData = res.data.usuario;
        localStorage.setItem('userRole', userData.role);
        localStorage.setItem('userId', userData.id);
        localStorage.setItem('userName', userData.identifier);
        
        this.$router.push('/dashboard');
      } catch (err) {
        this.error = err.response?.data?.mensaje || 'Error al iniciar sesión. Verifique sus credenciales.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$gradient-start-color: #1E88E5;
$gradient-end-color: #1565C0;

.login-container {
  background: linear-gradient(135deg, $gradient-start-color 0%, $gradient-end-color 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  border-radius: 10px;
  overflow: hidden;
  max-width: 500px;
  width: 90%;
}

.login-header {
  position: relative;
  padding-top: 16px;
}

.login-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  right: 20%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
}

.custom-title {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--v-primary-base, #1E88E5);
  margin: 0;
  line-height: 1.2;
  text-transform: uppercase;
}

.custom-subtitle {
  font-size: 22px;
  font-weight: 500;
  color: #585858;
  margin: 0;
  line-height: 1.2;
}
</style> 